import styles from './style.module.scss';
import getFormatMessage from '../../locales/get-format-message';
import classNames from 'classnames';
import { useState, useEffect } from 'react';
import { IProductsServiceItem } from '../../model/products';

interface IProps {
  readonly serviceData: IProductsServiceItem | null;
  readonly uniqueName: string;
}

export const ProductsNavComponent = (props: IProps) => {
  useEffect(() => {
    initNav();
  }, [props.uniqueName]);
  const [activeKey, setActiveKey] = useState<number>(0);
  const navList = [
    {
      label: getFormatMessage('products_features'),
      value: 0,
      id: 'nav-item-0',
      isShow:
        props.serviceData?.featuresConfig &&
        props.serviceData?.featuresConfig.length !== 0,
    },
    {
      label: getFormatMessage('products_key_benefits'),
      value: 1,
      id: 'nav-item-1',
      isShow:
        props.serviceData?.keyBenefitsConfig &&
        props.serviceData?.keyBenefitsConfig.length !== 0,
    },
    {
      label: getFormatMessage('products_typical_application'),
      value: 2,
      id: 'nav-item-2',
      isShow:
        props.serviceData?.typicalApplicationsConfig &&
        props.serviceData?.typicalApplicationsConfig.length !== 0,
    },
    {
      label: getFormatMessage('products_help_guides'),
      value: 3,
      id: 'nav-item-3',
      isShow: true,
    },
  ];

  const initNav = () => {
    setActiveKey(0);
    window.scrollTo(0, 0);
  };

  const handleNavClick = (id: string, key: number) => {
    setActiveKey(key);
    const element = document.getElementById(id);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth', block: 'start' });
    }
  };

  useEffect(() => {
    const handleScroll = () => {
      for (const sec of navList) {
        const el = document.getElementById(sec.id);
        if (el) {
          const rect = el.getBoundingClientRect();
          if (rect.top <= 80 && rect.bottom >= 80) {
            setActiveKey(sec.value);
            break;
          }
        }
      }
    };

    window.addEventListener('scroll', handleScroll, { passive: true });
    handleScroll(); // 初始也触发一次
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  return (
    <div className={styles.productsNavPaddingBox}>
      <div className={styles.productsNavBox}>
        {navList.map((item) => {
          if (!item.isShow) {
            return null;
          }
          return (
            <div
              className={classNames(
                styles.productsNav,
                activeKey === item.value ? styles.productsActiveNav : ''
              )}
              onClick={() => handleNavClick(item.id, item.value)}
            >
              {item.label}
            </div>
          );
        })}
      </div>
    </div>
  );
};
